module.exports = __webpack_public_path__ + "img/Right_rotation.613736fb.png";